// Dependencies
import React from 'react';

// Hooks
import useContactOptions from '../../../hooks/useContactOptions';

// Styles
import FormErrorStyles from './formError.styles';

export default function FormError() {
  const contactOptions = useContactOptions();
  const contactPhoneNumber = contactOptions?.phoneNumber;
  const contactEmail = contactOptions?.emailAddress;

  return (
    <FormErrorStyles>
      Error, please try again later. Alternatively, call us on{' '}
      {contactPhoneNumber} or email via {contactEmail}.
    </FormErrorStyles>
  );
}
